import ReactECharts from 'echarts-for-react';
import { useSettingsStore, COLOR_THEMES } from '@store/settingsStore';
import type { BaseChartProps } from '@/types';

export function EChart({
  option,
  height = '100%',
  width = '100%',
  loading,
  onEvents,
  className,
}: BaseChartProps) {
  const theme = useSettingsStore((s) => s.theme);
  const colorThemeKey = useSettingsStore((s) => s.colorTheme);

  const selectedTheme = COLOR_THEMES.find((t) => t.key === colorThemeKey) || COLOR_THEMES[0];
  const primaryColor = selectedTheme.color;

  // Build a beautiful, cohesive color palette starting with the selected primary color
  const palette = [
    primaryColor,
    '#0ea5e9', // Sky blue
    '#10b981', // Emerald green
    '#8b5cf6', // Violet purple
    '#f59e0b', // Amber yellow
    '#ec4899', // Pink rose
    '#14b8a6', // Teal
    '#ef4444', // Red
  ].filter((c, i, self) => self.indexOf(c) === i); // Deduplicate

  // Put primary color at the very front
  if (palette[0] !== primaryColor) {
    const idx = palette.indexOf(primaryColor);
    if (idx > -1) palette.splice(idx, 1);
    palette.unshift(primaryColor);
  }

  const mergedOption = {
    color: palette,
    backgroundColor: theme === 'dark' ? '#15151a' : '#ffffff',
    ...option,
  };

  return (
    <ReactECharts
      option={mergedOption}
      style={{ height, width }}
      theme={theme === 'dark' ? 'dark' : undefined}
      showLoading={loading}
      onEvents={onEvents}
      notMerge
      lazyUpdate
      className={className}
      opts={{ renderer: 'canvas' }}
    />
  );
}
